/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="showWordspotting && loaded"
  >
    <h1
      id="wordspottingheader"
    >
      Manage Wordspotting
    </h1>
    <manage-wordspotting />
  </div>
</template>


<style lang="less" scoped>
  .manage-menu li a {
    padding-left: 6px;
    padding-right: 6px;
  }
  #manageH1 {
    margin-top: 0 !important;
    padding-top: 0;
  }
</style>

<script>
import ManageWordspotting from '../layout/ManageWordspotting';
import BasePage from './BasePage';

export default {
  components: { ManageWordspotting },
  mixins: [BasePage],
  data() {
    return {
      loaded: false,
      tab: null,
      showSharedGroupsTabToSpeakers: false,
      showMyRecordingsTab: true,
    };
  },
  computed: {
    showWordspotting() {
      const org = this.$store.getters.org;
      const groups = (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Groups);
      const orgs = (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Orgs);
      const users = (org && typeof org.settings !== 'undefined' && org.settings.Custom_Wordspotting_For_Users);

      return ((groups && this.isGroupManager) || (orgs && this.isOrgLevelAdmin) || users);
    },
  },
  methods: {
    basePageCreated() {
      this.loaded = true;
    },
  }
};
</script>
